import { Box, Skeleton, Stack } from "@mui/material";
import { visuallyHidden } from "../../visuallyHidden";

/**
 * Loading state shaped like the real rows: a leading mark and two text lines
 * per row. The label stays available to screen readers ("Loading classes…").
 */
export function ListSkeleton({
  label = "Loading…",
  rows = 2,
  leading = "circle",
}: {
  label?: string;
  rows?: number;
  /** Match the real row: a round avatar, a square tile (dates, icons) or none. */
  leading?: "circle" | "square" | "none";
}) {
  return (
    <Stack role="status" aria-live="polite" spacing={1} data-testid="list-skeleton">
      <Box component="span" sx={visuallyHidden}>
        {label}
      </Box>
      {Array.from({ length: rows }, (_, index) => (
        <Stack
          key={index}
          aria-hidden
          data-testid="skeleton-row"
          direction="row"
          spacing={1.5}
          sx={{ alignItems: "center", px: { xs: 0.5, sm: 1 }, py: 0.75 }}
        >
          {leading === "none" ? null : (
            <Skeleton
              variant={leading === "circle" ? "circular" : "rounded"}
              width={44}
              height={44}
              sx={{ flexShrink: 0, borderRadius: leading === "square" ? "8px" : undefined }}
            />
          )}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Skeleton variant="rounded" height={12} sx={{ width: "70%", borderRadius: "6px" }} />
            <Skeleton variant="rounded" height={10} sx={{ width: "45%", mt: 1, borderRadius: "6px" }} />
          </Box>
        </Stack>
      ))}
    </Stack>
  );
}
